
export const OBJECT_FREEZE_HELPER = {

    // Congelamos de forma recursiva TODAS las propiedades de un objeto (Deep Freeze). Retorna objeto inmutable.
    DEEP_FREEZE: (OBJ) => {
        
        const propNames = Object.getOwnPropertyNames(OBJ);

        for (const name of propNames) {
            const value = OBJ[name];

            if (value && typeof value === "object") {
                OBJECT_FREEZE_HELPER.DEEP_FREEZE(value);
            }
        }

        return Object.freeze(OBJ);
    },

}
